export const LOGIN_REDIRECT_PARAM = 'redirect'

export const getSafeInternalPath = (path?: string | null): string => {
  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return ''
  }

  return path
}

export const getSafeLoginRedirect = (search: string): string => {
  const redirect = new URLSearchParams(search).get(LOGIN_REDIRECT_PARAM)

  return getSafeInternalPath(redirect)
}

export const buildLoginPathWithRedirect = (
  redirectPath: string,
  returnPath: string,
): string => {
  const [path, search = ''] = redirectPath.split('?')
  const params = new URLSearchParams(search)

  params.set(LOGIN_REDIRECT_PARAM, returnPath)

  return `${path}?${params.toString()}`
}

export const withCurrentSearch = (path: string): string => {
  const search = window.location.search

  return search ? `${path}${search}` : path
}
